import Vue from 'vue';
import Vuex from 'vuex';
import app from './app';
import user from './user';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        app,
        user
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js